import React from 'react';
import PropTypes from 'prop-types';

const TradeAccountManagerLink = React.lazy(() =>
    import(/* webpackChunkName: "TradeAccountManagerLink" */ './TradeAccountManagerLink')
);

export function TradeAccountManagerLinkLazy({
    isClient,
    hasRootPendingRefetch,
    hasUserId,
    userIds,
    viewer,
    userId,
}) {
    return (
        isClient && (
            <React.Suspense fallback="">
                <TradeAccountManagerLink
                    hasRootPendingRefetch={hasRootPendingRefetch}
                    hasUserId={hasUserId}
                    userIds={userIds}
                    viewer={viewer}
                    userId={userId}
                />
            </React.Suspense>
        )
    );
}

TradeAccountManagerLinkLazy.propTypes = {
    isClient: PropTypes.bool,
    hasRootPendingRefetch: PropTypes.bool,
    hasUserId: PropTypes.bool,
    userIds: PropTypes.array,
    viewer: PropTypes.object,
};
